import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthAppService } from 'avn/modules/services/auth-app/auth-app.service';
import { Observable } from 'rxjs';

@Injectable()
export class JWTAuthInterceptor implements HttpInterceptor {
  public constructor(private readonly auth: AuthAppService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.auth.getToken() || this.auth.getBackendToken()) {
      if (this.auth.clientType() === 'backend') {
        req = req.clone({
          setHeaders: {
            Authorization: `JWT ${this.auth.getBackendToken()}`,
            'Content-Type': 'application/json',
            Client: 'backend'
          }
        });
      } else {
        req = req.clone({
          setHeaders: {
            Authorization: `JWT ${this.auth.getToken()}`,
            'Content-Type': 'application/json',
            Client: 'frontend'
          }
        });
      }
    } else {
      req = req.clone({
        setHeaders: { 'Content-Type': 'application/json' }
      });
    }

    return next.handle(req);
  }
}
